// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O1YdX0mstJRM_IgXnn_t {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
    padding: 30px
}
.Z8YYhI9WBkOGYLI4Sk8W {
    min-height: 600px;
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.Svmjq4kt16bNUQ5ob4wA {
    height: 100%;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem
}
.xjzWuyxUjHV3mWBQ6qxa {
    height: 100%
}
.cvO1Upc7JkmfybyhdgLb {
    border-radius: 5px;
    padding: 1.25rem;
    text-align: center
}
.OLEClSM4alem80ig819s {
    margin-bottom: 0.625rem;
    display: flex;
    justify-content: center;
    font-size: 3.75rem;
    line-height: 1
}

.zLXNpEn1EDnjWhN0aB1r {
    margin-top: 15px;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 500
}
.I3Jw3Z9B9Xm59mKyWUIQ {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    --tw-border-opacity: 1;
    border-color: rgb(228 229 231 / var(--tw-border-opacity, 1))
}
.F2ebWWuwCH929njqRL5F {
    margin-top: 0.625rem;
    width: 100%
}

.sB4_zr1BikihkdouNjqC {
    border-radius: 10px;
    padding: 1.25rem;
    --tw-shadow: 0 4px 8px rgba(0,0,0,0.1);
    --tw-shadow-colored: 0 4px 8px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.YRJ9a5lz85nJJDY6ixNY {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.75rem
}
.iGGxKYkDffofeA3_OEat {
    margin-bottom: 0.625rem;
    font-size: 1rem;
    line-height: 1.5rem
}
.iGGxKYkDffofeA3_OEat span {
    font-family: bold
}
.bJOVQVthYwdX5SVVdvx5 {
    display: flex;
    flex-direction: column
}
.KnGUCxWMRYYN7cZl3hKg {
    cursor: pointer;
    border-color: none;
    background-color: none;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.OjXw6LW0ZsbslguAZYoa {
    width: 100%;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.f2AKVH6b6wb44fnTaokJ {
    border-left-width: 1px;
    border-style: solid;
    --tw-border-opacity: 1;
    border-left-color: rgb(228 229 231 / var(--tw-border-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/pages/Setting/Setting.module.css"],"names":[],"mappings":"AACE;IAAA,kBAAmC;IAAnC,4DAAmC;IAAnC;AAAmC;AAGnC;IAAA,iBAAqD;IAArD,kBAAqD;IAArD,kBAAqD;IAArD,4DAAqD;IAArD,+EAAqD;IAArD,mGAAqD;IAArD;AAAqD;AAGrD;IAAA,YAAuB;IAAvB,qBAAuB;IAAvB,sBAAuB;IAAvB,oBAAuB;IAAvB;AAAuB;AAGvB;IAAA;AAAa;AAGb;IAAA,kBAAoC;IAApC,gBAAoC;IAApC;AAAoC;AAGpC;IAAA,uBAA0C;IAA1C,aAA0C;IAA1C,uBAA0C;IAA1C,kBAA0C;IAA1C;AAA0C;;AAI1C;IAAA,gBAAoC;IAApC,mBAAoC;IAApC,oBAAoC;IAApC;AAAoC;AAGpC;IAAA,gBAAoC;IAApC,iBAAoC;IAApC,mBAAoC;IAApC,sBAAoC;IAApC,sBAAoC;IAApC;AAAoC;AAGpC;IAAA,oBAAoB;IAApB;AAAoB;;AAIpB;IAAA,mBAA4D;IAA5D,gBAA4D;IAA5D,sCAA4D;IAA5D,qDAA4D;IAA5D;AAA4D;AAG5D;IAAA,sBAAmB;IAAnB,kBAAmB;IAAnB;AAAmB;AAGnB;IAAA,uBAAuB;IAAvB,eAAuB;IAAvB;AAAuB;AAGvB;IAAA;AAAkB;AAGlB;IAAA,aAAoB;IAApB;AAAoB;AAGpB;IAAA,eAAyF;IAAzF,kBAAyF;IAAzF,sBAAyF;IAAzF,kBAAyF;IAAzF,mBAAyF;IAAzF,oBAAyF;IAAzF,uBAAyF;IAAzF,mBAAyF;IAAzF,oBAAyF;IAAzF,gBAAyF;IAAzF,oBAAyF;IAAzF;AAAyF;AAGzF;IAAA,WAAkD;IAAlD,uBAAkD;IAAlD,kBAAkD;IAAlD,0DAAkD;IAAlD,oBAAkD;IAAlD;AAAkD;AAGlD;IAAA,sBAAkD;IAAlD,mBAAkD;IAAlD,sBAAkD;IAAlD;AAAkD","sourcesContent":[".container {\n  @apply bg-layoutBackground p-[30px];\n}\n.innerContainer {\n  @apply bg-white min-h-[600px] rounded-[5px] shadow-lg;\n}\n.profileContainer {\n  @apply h-full px-5 py-5;\n}\n.profileContainerRow {\n  @apply h-full;\n}\n.profileCard {\n  @apply text-center p-5 rounded-[5px];\n}\n.avatar {\n  @apply text-6xl flex justify-center mb-2.5;\n}\n\n.name {\n  @apply text-lg font-medium mt-[15px];\n}\n.separator {\n  @apply mx-0 my-5 border-dividerColor;\n}\n.editButton {\n  @apply w-full mt-2.5;\n}\n\n.detailsCard {\n  @apply shadow-[0_4px_8px_rgba(0,0,0,0.1)] p-5 rounded-[10px];\n}\n.cardTitle {\n  @apply text-xl mb-5;\n}\n.infoRow {\n  @apply text-base mb-2.5;\n}\n.infoRow span {\n  @apply font-[bold];\n}\n.tabsContainer {\n  @apply flex flex-col;\n}\n.tabButton {\n  @apply font-normal cursor-pointer text-gray-400 text-sm px-4 py-3 border-[none] bg-[none];\n}\n.active {\n  @apply text-[white] bg-secondary w-full rounded-md;\n}\n.tabContent {\n  @apply border-l-dividerColor border-l border-solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `O1YdX0mstJRM_IgXnn_t`,
	"innerContainer": `Z8YYhI9WBkOGYLI4Sk8W`,
	"profileContainer": `Svmjq4kt16bNUQ5ob4wA`,
	"profileContainerRow": `xjzWuyxUjHV3mWBQ6qxa`,
	"profileCard": `cvO1Upc7JkmfybyhdgLb`,
	"avatar": `OLEClSM4alem80ig819s`,
	"name": `zLXNpEn1EDnjWhN0aB1r`,
	"separator": `I3Jw3Z9B9Xm59mKyWUIQ`,
	"editButton": `F2ebWWuwCH929njqRL5F`,
	"detailsCard": `sB4_zr1BikihkdouNjqC`,
	"cardTitle": `YRJ9a5lz85nJJDY6ixNY`,
	"infoRow": `iGGxKYkDffofeA3_OEat`,
	"tabsContainer": `bJOVQVthYwdX5SVVdvx5`,
	"tabButton": `KnGUCxWMRYYN7cZl3hKg`,
	"active": `OjXw6LW0ZsbslguAZYoa`,
	"tabContent": `f2AKVH6b6wb44fnTaokJ`
};
export default ___CSS_LOADER_EXPORT___;
